<h2>Payment Share Modal (Patient Name:- {{leadName}})</h2>
<form [formGroup]="PlanForm" (submit)="share_plan()">
<mat-radio-group
  aria-labelledby="example-radio-group-label"
  class="example-radio-group"
  formControlName="product_type">
  <mat-radio-button class="example-radio-button" *ngFor="let product of products" [value]="product.id">
    {{product.name}}
  </mat-radio-button>
</mat-radio-group>
<div *ngIf="submitted && f.product_type.errors" class="invalid-feedback">
    <div *ngIf="f.product_type.errors.required">Please select product</div>
</div>


    <mat-form-field class="example-full-width" appearance="fill">
      <mat-label>Amount</mat-label>
      <input matInput formControlName="amount">
    </mat-form-field>
    <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
        <div *ngIf="f.amount.errors.required">Please Enter Amount</div>
    </div>
    
<br>

<button type="submit" [disabled]="loading" class="btn btn-primary mt-2" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>Share Link</button>
<button type="button" (click)="ClosePlanModal()" class="btn btn-default mt-2 marleft">Close</button>
</form>
<div *ngIf="show_copy" class="margintp20">
  <button type="button" class="copy_btn" (click)="copyToClipboard(sharableLink)">Copy link</button>
  <input readonly type="text" [(ngModel)]="copypaymentlink" #sharableLink>
</div>

